import React, { Component } from 'react';
import { CloseIcon, UploadIcon } from '../shared/icons';
import styles from './index.module.scss';

class UploadBookingCopyModal extends Component {
  constructor(props) {
    super(props);
    this.state = { dragOver: false, file: null };
    this.fileRef = React.createRef();
  }

  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) this.setState({ file, dragOver: false });
  };

  handleFile = (e) => {
    const file = e.target.files[0];
    if (file) this.setState({ file });
  };

  handleSubmit = () => {
    const { onUpload } = this.props;
    if (!this.state.file) return;
    if (onUpload) onUpload(this.state.file);
  };

  render() {
    const { rfq, onClose, submitting } = this.props;
    const { dragOver, file } = this.state;

    return (
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={e => e.stopPropagation()}>
          <div className={styles.header}>
            <span className={styles.title}>Upload Booking Copy</span>
            <button className={styles.closeBtn} onClick={onClose}><CloseIcon /></button>
          </div>
          <div className={styles.subtitle}>RFQ {rfq.rfqNumber}</div>

          <div
            className={`${styles.dropZone} ${dragOver ? styles.dragOver : ''}`}
            onDragOver={e => { e.preventDefault(); this.setState({ dragOver: true }); }}
            onDragLeave={() => this.setState({ dragOver: false })}
            onDrop={this.handleDrop}
            onClick={() => this.fileRef.current.click()}
          >
            <input ref={this.fileRef} type="file" accept=".pdf,.png,.jpg,.jpeg" style={{ display: 'none' }} onChange={this.handleFile} />
            <div className={styles.dropIconCircle}><UploadIcon size={22} /></div>
            <div className={styles.dropMain}>Drop file here or click to browse</div>
            <div className={styles.dropSub}>PDF, PNG, JPG up to 10MB</div>
            {file && <div className={styles.fileName}>{file.name}</div>}
          </div>

          <div className={styles.footer}>
            <button className={styles.cancelBtn} onClick={onClose}>Cancel</button>
            <button className={styles.uploadBtn} onClick={this.handleSubmit} disabled={submitting || !file}>
              <UploadIcon size={14} /> {submitting ? 'Uploading...' : 'Upload Booking Copy'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadBookingCopyModal;
